import { SkeletonChild, SkeletonParent } from '@/components/ui/Skeleton/skeleton';

export const GmBundleOffersSkeleton = () => {
  return (
    <div className="flex flex-col md:items-start items-center gap-3 md:gap-5">
      <SkeletonParent className="rounded-lg w-fit md:block hidden">
        <SkeletonChild className="rounded-[inherit] h-5.5 w-29.5" />
      </SkeletonParent>

      <SkeletonParent className="md:hidden block h-33 rounded-2xl w-full">
        <SkeletonChild className="rounded-[inherit]" />
      </SkeletonParent>

      <SkeletonParent className="md:hidden block h-[0.313rem] w-10.5 rounded-[0.188rem]">
        <SkeletonChild className="rounded-[inherit]" />
      </SkeletonParent>

      <div className="hidden md:flex gap-5 w-full">
        {
          Array.from({ length: 3 }).map(
            (_, i) => (
              <SkeletonParent
                key={i}
                className="flex w-full justify-between gap-2 h-33 rounded-2xl"
              >
                <div className="flex flex-col gap-2 p-4 pr-0">
                  <SkeletonChild className="rounded-full h-6 w-[6.438rem]" />
                  <SkeletonChild className="rounded-full h-6 w-[6.438rem]" />
                  <SkeletonChild className="rounded-full h-8 w-22.5" />
                </div>

                <SkeletonChild className="h-33 w-[8.813rem] rounded-xl" />
              </SkeletonParent>
            ),
          )
        }
      </div>
    </div>
  );
};
